export default {
  metadata: {
    version: '1.0.0',
    id: 'side-panel-1.0.0',
    name: 'JDSSidePanelInternal',
    description: ''
  },
  hierarchy: {
    container: [
      {
        'header-container': [
          {
            'left-container': ['avatar-slot', 'header-text-slot']
          },
          'suffix-jds_action_button'
        ]
      },
      'children-slot',
      {
        'section-container': ['jds_side_panel_item']
      }
    ]
  },
  base: {
    container: {
      width: 412,
      height: '{s_5}',
      'flex-direction': '{s_6}',
      'background-color': '{s_7}',
      'enter-animation-name': 'slideHorizontallyToRight',
      'exit-animation-name': 'slideHorizontallyToLeft',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      hidden: true,
      'translate-x': '{size.negativeMax}',
      transition: {
        property: ['translate-x'],
        duration: '{medium}',
        'timing-function': '{easeRapid}'
      }
    },
    'section-container': {
      hidden: true,
      height: '{s_8}',
      width: '{s_9}',
      'flex-direction': '{s_10}',
      'justify-content': '{s_11}',
      'align-items': '{s_12}',
      'padding-left': '{s_13}',
      'padding-top': '{s_14}',
      'padding-right': '{s_15}'
    },
    'header-container': {
      'background-color': '{s_16}',
      'padding-top': '{s_17}',
      'padding-bottom': '{s_18}',
      'padding-right': '{s_19}',
      'padding-left': '{s_20}',
      width: '{s_21}',
      'justify-content': '{s_22}',
      'align-items': '{s_23}'
    },
    'left-container': {
      'flex-direction': '{s_24}',
      gap: '{s_25}',
      'align-items': '{s_26}'
    },
    'suffix-jds_action_button': {
      hidden: false,
      icon: 'ic_close',
      size: 'large'
    }
  },
  variant: {
    open: {
      true: {
        container: {
          hidden: false,
          'translate-x': 0,
          transition: {
            'timing-function': '{easeEntrance}'
          }
        }
      }
    },
    direction: {
      right: {
        container: {
          'enter-animation-name': 'slideHorizontallyToLeft',
          'exit-animation-name': 'slideHorizontallyToRight'
        }
      }
    },
    showClose: {
      false: {
        'suffix-jds_action_button': {
          hidden: true
        }
      }
    },
    _hasChildren: {
      true: {
        'section-container': {
          hidden: false
        },
        'children-slot': {
          hidden: true
        }
      }
    }
  },
  combination: [
    {
      true: {
        desktop: {
          container: {
            width: '{s_28}'
          }
        },
        mobile: {
          container: {
            width: '{s_29}'
          }
        }
      },
      false: {
        desktop: {
          container: {
            width: 412
          }
        },
        mobile: {
          container: {
            width: '{s_30}'
          }
        }
      }
    },
    {
      false: {
        right: {
          container: {
            'translate-x': '{size.max}'
          }
        }
      }
    }
  ],
  combination_config: [
    ['maxWidth', '_platform'],
    ['open', 'direction']
  ],
  api: {
    children: {
      'avatar-slot': {
        name: 'prefix',
        accepts: ['jds_avatar', 'jds_icon', 'jds_button'],
        max: 1
      },
      'header-text-slot': {
        name: 'header',
        accepts: ['jds_text'],
        max: 1,
        doc_description: 'Has pre-defined suffix as close button.'
      },
      'children-slot': {
        name: 'children',
        accepts: ['any'],
        doc_description:
          'Any group of children can be added. When used for BurgerMenu, show a list of ListBlocks.'
      }
    },
    config: {
      _platform: {
        values: ['desktop', 'mobile']
      },
      direction: {
        values: ['left', 'right'],
        doc_description:
          'Determines whether open/close should happen from left or right.'
      },
      showClose: {
        values: [true, false],
        doc_description: 'Whether a close on the right should be shown.'
      },
      open: {
        values: [false, true],
        doc_description:
          'Can be used to programatically open/close the drawer with animation and selected direction.'
      },
      maxWidth: {
        values: [false, true],
        doc_description:
          'If set it will limit max width of the panel to 412px.',
        function: true
      },
      _hasChildren: {
        values: [false, true]
      },
      disableTransition: {
        values: [false, true],
        platform: 'web'
      }
    },
    data: {
      'section-container': {
        value: {
          type: 'list',
          name: 'items',
          object: {
            title: 'string',
            prefix: 'icon',
            showSuffix: 'boolean',
            type: 'JDSSidePanelItem.type'
          }
        }
      },
      jds_side_panel_item: {
        prefix: {
          type: 'string',
          name: 'items.prefix'
        },
        title: {
          type: 'string',
          name: 'items.title'
        },
        showSuffix: {
          type: 'boolean',
          name: 'links.showSuffix'
        },
        type: {
          type: 'string',
          name: 'items.type'
        }
      }
    },
    events: {
      'suffix-jds_action_button': {
        onClick: 'onClose'
      },
      container: {
        onClick: 'onContainerClick',
        onSwipeLeft: 'onSwipeLeft'
      },
      jds_side_panel_item: {
        onSuffixClick: 'onSidePanelSuffixClick'
      }
    },
    a11y: {
      'suffix-jds_action_button': {
        properties: {
          ariaLabel: {
            name: 'suffixAriaLabel',
            value: 'Close Side Panel'
          }
        }
      },
      'section-container': {
        name: 'items',
        properties: {
          role: {
            value: 'list'
          }
        },
        repeating: {
          ariaLabel: 'itemAriaLabel',
          itemSuffixAriaLabel: 'itemSuffixAriaLabel',
          ariaDescribedby: {
            name: 'itemAriaDescribedby',
            platform: 'web,ios'
          }
        }
      },
      jds_side_panel_item: {
        properties: {
          ariaLabel: 'items.itemAriaLabel',
          itemSuffixAriaLabel: 'items.itemSuffixAriaLabel',
          ariaDescribedby: 'items.itemAriaDescribedby'
        }
      }
    }
  }
};
